import { styled } from '@mui/material';
import React from 'react';

export interface ArrowProps {
  open: boolean;
}

const BoxArrowUp = styled('i')(({ theme }) => ({
  border: 'solid #8B8296',
  borderWidth: '0 1.5px 1.5px 0',
  display: 'inline-block',
  padding: '3px',
  transform: 'rotate(-135deg)',
  width: '3px',
}));

const BoxArrowDown = styled('i')(({ theme }) => ({
  border: 'solid #8B8296',
  borderWidth: '0 1.5px 1.5px 0',
  display: 'inline-block',
  padding: '3px',
  transform: 'rotate(45deg)',
  width: '3px',
}));

export const Arrow = (props: ArrowProps) => {
  if (props.open) {
    return <BoxArrowUp></BoxArrowUp>;
  }
  return <BoxArrowDown></BoxArrowDown>;
};
